<template>
    <div class="row mb-4">
        <div class="card col-sm-4 col-md-2 p-0">
            <div class="card-header text-primary p-2" style="font-weight: bold; font-size: 1.1em;">
                Всичко разходи
            </div>
            <div class="card-body text-primary">
                <div class="font-weight-bold text-right" style="font-weight: bold; font-size: 1.2em;">{{ totalCosts }}</div>
            </div>
        </div>
        <div class="card col-sm-4 col-md-2 p-0">
            <div class="card-header text-muted p-2">
                Сума дневни
            </div>
            <div class="card-body">
                <div class="font-weight-bold text-right" style="font-weight: bold; font-size: 1.2em;">{{ daysSum }}</div>
            </div>
        </div>
        <div class="card col-sm-4 col-md-2 p-0">
            <div class="card-header text-muted p-2">
                Сума квартирни
            </div>
            <div class="card-body">
                <div class="font-weight-bold text-right" style="font-weight: bold; font-size: 1.2em;">{{ apartmentSum }}</div>
            </div>
        </div>
        <div class="card col-sm-4 col-md-2 p-0">
            <div class="card-header text-muted p-2">
                Пътни
            </div>
            <div class="card-body">
                <div class="font-weight-bold text-right" style="font-weight: bold; font-size: 1.2em;">{{ roadSum }}</div>
            </div>
        </div>
        <div class="card col-sm-4 col-md-2 p-0">
            <div class="card-header text-muted p-2">
                Всичко<small class="ml-1">(дневни, квартирни, пътни)</small>
            </div>
            <div class="card-body">
                <div class="font-weight-bold text-right" style="font-weight: bold; font-size: 1.2em;">{{ allMoneySum }}</div>
            </div>
        </div>
        <div class="card col-sm-4 col-md-2 p-0">
            <div class="card-header text-muted p-2">
                Изплатени разходи<small class="ml-1">(дневни, квартирни, пътни)</small>
            </div>
            <div class="card-body">
                <div class="font-weight-bold text-right" style="font-weight: bold; font-size: 1.2em;">{{ paid }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import helpers from '../../helpers/helpers';

    export default {
        props: {
            registerEntityId: {
                type: [Number, String],
                required: true
            },
            expensesTotalCosts: {
                type: [Number, String],
                default() {
                    return ''
                }
            }
        },
        data() {
            return {
                loading: true,
                daysSum: 0,
                apartmentSum: 0,
                roadSum: 0,
                allMoneySum: 0,
                paid: 0,
            }
        },
        mounted () {
            this.init();
        },
        computed: {
            totalCosts() {
                const total = this.allMoneySum + this.expensesTotalCosts;

                return isNaN(total) ? null : Math.round(total * 100) / 100;
            }
        },
        methods: {
            init() {
                this.loading = true;
                this.$http.get(`/api/BudgetReport/GetForExpenses/${this.registerEntityId}`).then(result => {
                    if (result.data) {
                        this.daysSum = helpers.roundToSecondDigit(result.data.daysSum || 0);
                        this.apartmentSum = helpers.roundToSecondDigit(result.data.apartmentSum || 0);
                        this.roadSum = helpers.roundToSecondDigit(result.data.roadSum || 0);
                        this.allMoneySum = helpers.roundToSecondDigit(this.daysSum + this.apartmentSum + this.roadSum);
                        this.paid = helpers.roundToSecondDigit(result.data.paid || 0);
                    }
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                });
            }
        }
    }
</script>
